module.exports = __webpack_public_path__ + "static/media/card_smaller_octupuses.d1d16de1.jpg";